const widgetDelete = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M12.247 2.5 13.5 3.753 9.253 8l4.247 4.247-1.253 1.253L8 9.253 3.753 13.5 2.5 12.247 6.746 8 2.5 3.753 3.753 2.5 8 6.746z"/></svg>',
};

export { widgetDelete as default };
